import {
  CategoryStyleTypes,
  IBlogCategories,
} from "@/api/AppApi/services/home/interfaces/ICategory";
import BlogCategory from "./BlogCategory";
import { Col, Row } from "../../lib/my-bootstrap";

interface Props extends IBlogCategories {
  showCategoryImage: boolean;
}

const BlogCategoryGrid = (props: Props) => {
  return (
    <Row className="m-0 d-flex justify-content-center" style={{ gap: 16 }}>
      {props.data?.map((item) => (
        <Col className="col-auto p-0" key={item.key}>
          <BlogCategory
            customize={props?.configurations?.customize!}
            showCategoryImage={props.showCategoryImage}
            categoryType={
              props.configurations?.style_type ?? CategoryStyleTypes.circle_icon
            }
            categoryKey={item.key}
            {...item}
          />
        </Col>
      ))}
    </Row>
  );
};

export default BlogCategoryGrid;
